export const MA_MY_PROFILE_LOADER = {
  desktop: `
<div class="cui-grid cui-container -spacing--top-64 -spacing--bottom-120">
  <div class="cui-row">
    <div class="cui-col-lg-10 cui-col-xl-8">
      <div class="cui-skeleton-paragraph -spacing--bottom-40">
        <div class="cui-skeleton-paragraph__content" style="width: 160px">
          <div class="cui-skeleton__item" style="height: 16px"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--large -spacing--bottom-40 -resolution--desktop">
        <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
            <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        </div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-40">
        <div class="cui-skeleton__item" style="height: 64px;"></div>
      </div>
      <div class="-spacing--bottom-40" style="display: flex; justify-content: space-between; align-items: center;">
        <div class="cui-skeleton-rectangle" style="width: min(320px, 46%); display: flex; flex-direction: column; row-gap: 8px">
          <div class="cui-skeleton__item" style="height: 28px;"></div>
          <div class="cui-skeleton__item" style="height: 18px;"></div>
        </div>
        <div class="cui-skeleton-rectangle" style="width: 96px">
          <div class="cui-skeleton__item" style="height: 28px;"></div>
        </div>
      </div>
      <div class="-spacing--bottom-40" style="display: flex; justify-content: space-between; align-items: center;">
        <div class="cui-skeleton-rectangle" style="width: min(320px, 46%); display: flex; flex-direction: column; row-gap: 8px">
          <div class="cui-skeleton__item" style="height: 28px;"></div>
          <div class="cui-skeleton__item" style="height: 18px;"></div>
        </div>
        <div class="cui-skeleton-rectangle" style="width: 96px">
          <div class="cui-skeleton__item" style="height: 28px;"></div>
        </div>
      </div>
      <div class="-spacing--bottom-40" style="display: flex; justify-content: space-between; align-items: center;">
        <div class="cui-skeleton-rectangle" style="width: min(320px, 46%); display: flex; flex-direction: column; row-gap: 8px">
          <div class="cui-skeleton__item" style="height: 28px;"></div>
          <div class="cui-skeleton__item" style="height: 18px;"></div>
        </div>
        <div class="cui-skeleton-rectangle" style="width: 96px">
          <div class="cui-skeleton__item" style="height: 28px;"></div>
        </div>
      </div>
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <div class="cui-skeleton-rectangle" style="width: min(320px, 46%); display: flex; flex-direction: column; row-gap: 8px">
          <div class="cui-skeleton__item" style="height: 28px;"></div>
          <div class="cui-skeleton__item" style="height: 18px;"></div>
        </div>
        <div class="cui-skeleton-rectangle" style="width: 96px">
          <div class="cui-skeleton__item" style="height: 28px;"></div>
        </div>
      </div>
    </div>
  </div>
</div>`
};
